import { PublicKey } from '@solana/web3.js'

// Single consolidated program
export const DRILL_GAME_PROGRAM_ID = new PublicKey('DiACg9jYVbvwXrUhXeMuj4895Ms1WhL7w6bpxBezBupx')

// MagicBlock delegation program IDs
export const DELEGATION_PROGRAM_ID = new PublicKey('DELeGGvXpWV2fqJUhqcF5ZSYMS4JTLjteaAMARRSaeSh')
export const MAGIC_PROGRAM_ID = new PublicKey('Magic11111111111111111111111111111111111111')
export const MAGIC_CONTEXT_ID = new PublicKey('MagicContext1111111111111111111111111111111')

const encoder = new TextEncoder()

/**
 * Derive the PlayerState PDA for a given authority.
 * Seeds: ["player_state", authority]
 */
export function getPlayerStatePDA(authority: PublicKey): [PublicKey, number] {
  return PublicKey.findProgramAddressSync(
    [encoder.encode('player_state'), authority.toBytes()],
    DRILL_GAME_PROGRAM_ID
  )
}

/**
 * Derive the RunState PDA for a given authority.
 * Seeds: ["run_state", authority]
 */
export function getRunStatePDA(authority: PublicKey): [PublicKey, number] {
  return PublicKey.findProgramAddressSync(
    [encoder.encode('run_state'), authority.toBytes()],
    DRILL_GAME_PROGRAM_ID
  )
}

/**
 * Derive the delegation-related PDAs for a given account pubkey.
 * buffer_pda is derived against the owner program (drill-game).
 * delegation_record and delegation_metadata are derived against the delegation program.
 */
export function getDelegationPDAs(accountPubkey: PublicKey): {
  bufferPda: PublicKey
  delegationRecordPda: PublicKey
  delegationMetadataPda: PublicKey
} {
  const [bufferPda] = PublicKey.findProgramAddressSync(
    [encoder.encode('buffer'), accountPubkey.toBytes()],
    DRILL_GAME_PROGRAM_ID
  )
  const [delegationRecordPda] = PublicKey.findProgramAddressSync(
    [encoder.encode('delegation'), accountPubkey.toBytes()],
    DELEGATION_PROGRAM_ID
  )
  const [delegationMetadataPda] = PublicKey.findProgramAddressSync(
    [encoder.encode('delegation-metadata'), accountPubkey.toBytes()],
    DELEGATION_PROGRAM_ID
  )
  return { bufferPda, delegationRecordPda, delegationMetadataPda }
}
